var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { useCallback, useState } from "react";
import styled from "styled-components";
import { Button, RatingBar, TextInput, TextAreaInput } from "..";
import { SizeEnum } from "../../enums";
var RatingWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: grid;\n  grid-template-columns: 100%;\n  grid-gap: 1rem;\n"], ["\n  display: grid;\n  grid-template-columns: 100%;\n  grid-gap: 1rem;\n"])));
var ReviewForm = function (_a) {
    var _b = _a.size, size = _b === void 0 ? SizeEnum.medium : _b;
    var _c = useState(""), title = _c[0], setTitle = _c[1];
    var _d = useState(""), description = _d[0], setDescription = _d[1];
    var _e = useState(0), currRating = _e[0], setRating = _e[1];
    var handleChangeRating = useCallback(function (value) {
        setRating(value);
    }, []);
    var handleChangeTitle = useCallback(function (e) {
        setTitle(e.target.value);
    }, []);
    var handleChangeDescription = useCallback(function (e) {
        setDescription(e.target.value);
    }, []);
    return (React.createElement(RatingWrapper, null,
        React.createElement(RatingBar, { isEditable: true, rating: currRating, onChange: handleChangeRating }),
        React.createElement(TextInput, { inputSize: size, value: title, onChange: handleChangeTitle, label: "Add a headline", helpText: "What is most important to know?" }),
        React.createElement(TextAreaInput, { size: size, value: description, onChange: handleChangeDescription, label: "Add a written review", helpText: "What do you like or dislike?" }),
        React.createElement(Button, { emphasis: "primary" }, "Submit")));
};
export default ReviewForm;
var templateObject_1;
